export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener("load", () => {
    const publicUrl = new URL(process.env.PUBLIC_URL || "/", window.location.href);

    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    navigator.serviceWorker.register(`${publicUrl.pathname}service-worker.js`).catch(() => {
      // La aplicación sigue operativa en navegadores o despliegues sin service workers.
    });
  });
}
